import React from "react";
import Breadcrumb from "../../../core/common/Breadcrumb/breadcrumb";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import StudentSidebar from "../common/studentSidebar";
import ProfileCard from "../common/profileCard";
import { useSelector } from "react-redux";
import { renderLexicalRichText } from "../../../utility/lexical-viewer";
import DOMPurify from 'dompurify';

const StudentProfile = () => {

    const user = useSelector((state: any) => state.auth.user);
    const dateOptions: Intl.DateTimeFormatOptions = {
        day: "2-digit",
        month: "short",
        year: "numeric",
    };

    function calculateAge(dobString: string): number {
        const dob: Date = new Date(dobString);
        const today: Date = new Date();

        let age: number = today.getFullYear() - dob.getFullYear();

        const hasHadBirthdayThisYear: boolean =
            today.getMonth() > dob.getMonth() ||
            (today.getMonth() === dob.getMonth() && today.getDate() >= dob.getDate());

        if (!hasHadBirthdayThisYear) {
            age--;
        }

        return age;
    }

    return (
        <>
            <div className="content">
                <div className="container">
                    {/* profile box */}
                    <ProfileCard />
                    {/* profile box */}
                    <div className="row">
                        {/* sidebar */}
                        <StudentSidebar />
                        {/* sidebar */}
                        <div className="col-lg-9">
                            <div className="page-title d-flex align-items-center justify-content-between">
                                <h5 className="fw-bold">My Profile</h5>
                                {/* <Link to="#" className="edit-profile-icon">
                                    <i className="isax isax-edit-2" />
                                </Link> */}
                            </div>
                            <div className="card mb-0">
                                <div className="card-body">
                                    <h6 className="fs-18 page-title fw-bold">
                                        Basic Information
                                    </h6>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="mb-3">
                                                <h6>First Name</h6>
                                                <span>{user?.firstName || '-'}</span>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="mb-3">
                                                <h6>Last Name</h6>
                                                <span>{user?.lastName || '-'}</span>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="mb-3">
                                                <h6>Registration Date</h6>
                                                <span>{user?.createdAt ? new Date(user.createdAt).toLocaleDateString('en-IN', dateOptions) : '-'}</span>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="mb-3">
                                                <h6>User Name</h6>
                                                <span>{user?.username || '-'}</span>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="mb-3">
                                                <h6>Phone Number</h6>
                                                <span>{user?.phone || '-'}</span>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="mb-3">
                                                <h6>Email</h6>
                                                <span>{user?.email || '-'}</span>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="mb-3">
                                                <h6>Gender</h6>
                                                <span>{user?.gender || '-'}</span>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="mb-3">
                                                <h6>DOB</h6>
                                                <span>{user?.dob ? new Date(user.dob).toLocaleDateString('en-IN', dateOptions) : '-'}</span>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="mb-3">
                                                <h6>Age</h6>
                                                <span>{user?.dob ? calculateAge(user.dob) : '-'}</span>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default StudentProfile;
